import { spacingSmall, maxSizeDesktop, spacingExtraLarge } from 'helpers/style';
import Color from 'color';
import { Flex } from '../Flex';
import styled from '@emotion/styled';

const lightenRgb = (color) =>
    Color(color)
        .alpha(0.75)
        .string();

export const Legend = styled(Flex)`
    background-color: ${(p) => p.theme.color.gray3};
    align-items: center;
    flex-wrap: wrap;

    padding: ${spacingSmall} ${spacingExtraLarge};
    ${maxSizeDesktop} {
        padding: ${spacingSmall};
    }
    min-height: 32px;
`;

export const RoundSquare = styled.div`
    width: 100%;
    background-color: ${(props) => lightenRgb(props.color)};
    border: 1px solid ${(props) => props.color};
    color: ${(p) => p.theme.color.black};
    width: 16px;
    height: 16px;
    line-height: 15px;
    border-radius: 2px;
    font-size: 11px;
    vertical-align: middle;
    text-align: center;
    margin: ${spacingSmall};
    margin-right: 8px;
`;

export const LegendItem = styled.div`
    display: flex;
    flex-wrap: nowrap;

    align-items: center;
    color: white;
    margin-right: 32px;
`;
